
import "react-app-polyfill/ie11";
import "react-perfect-scrollbar/dist/css/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./shared/styles/index.scss";
import React, { useContext } from "react";
import ReactDOM from "react-dom";
import 'react-toastify/dist/ReactToastify.css';
import "./css/toastify.css"
import { ToastContainer } from 'react-toastify';

import {
  ApolloClient,
  ApolloProvider,
  DefaultOptions,
  InMemoryCache,
  createHttpLink,
  gql,
} from "@apollo/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { setContext } from "@apollo/client/link/context";
import { getUserEmail } from "@crema/utility/AppHooks";
import jwtAxios, { setAuthToken } from "@crema/services/ApiConfig";
import { useHistory } from "react-router-dom";
import AppContextPropsType from "types/AppContextPropsType";
import { AppContext } from "@crema";


// const {updateAuthUser} = useContext<AppContextPropsType>(AppContext);
// const history = useHistory();
export const fetchDataApi = (email:string,refreshToken:String) => {

  // console.log( "in auth in fetchDataApi;")
  const apolloHttpLink1 = createHttpLink({
    uri: process.env.REACT_APP_API_URL,
  });
  const client1 = new ApolloClient({
    link: apolloHttpLink1.concat(apolloHttpLink1),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  });


  
  return new Promise((resolve, reject) => {
    // console.log( "in auth before Promise;");
    client1
    .mutate({
      mutation: gql`
mutation{
  refreshToken(
resource:{
  resourceType:User,
  email:"${email}"
    refreshToken:"${refreshToken}"

}){
  status
  message
  tokenresult
}
}


`,
    })
    .then((result) => {
     // console.log( "in auth before Promise::",result.data.refreshToken);
      if(result !=null && result.data !=null  &&  result.data.refreshToken !=null && result.data.refreshToken.status==1){
        let tokenData =JSON.parse(result.data.refreshToken.tokenresult);
        let refreshToken = tokenData['refreshToken']['token'];
        let accesToken = tokenData['accessToken']['jwtToken'];

        let tokenExpiryDate = tokenData['accessToken']['payload']['exp'];
        localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("accesToken", accesToken);
            localStorage.setItem("tokenExpiryDate", tokenExpiryDate);
            // console.log("refershtoken::",refreshToken)
        resolve(1);

      }else{
        // console.log( "in auth before else 0 ;");
        window.location.href="/login"
        resolve(0);
       
        //logout user
      }
       //logout API goes Here
   
      //  updateAuthUser(null);
      //  setAuthToken(null);
      //  history.push("/signin");
      


    });

    //add here
   
  });
};

const authLink = setContext(async (request, { headers }) => {
  // console.log("request.operationName1::", JSON.stringify(request));
  // console.log("request.operationName1::", request.operationName);

  var now = new Date;
  var utc_timestamp = Date.UTC(now.getFullYear(),now.getMonth(), now.getDate() , 
        now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

//    const tokenEDate = new Date(1658840492);

let currentTime =  Math.floor(utc_timestamp/1000)


  // get the authentication token from local storage if it exists
  let refreshToken='';
  let refreshTokenL = localStorage.getItem("refreshToken");
  if(refreshTokenL){
    refreshToken=refreshTokenL;
  }
  let accesToken = localStorage.getItem("accesToken");
  let tokenExpiryDate  = localStorage.getItem("tokenExpiryDate");
  if(tokenExpiryDate!=null && accesToken!=null)
  {
    let tokenExpiryDate1=parseInt(tokenExpiryDate);
    
    if(tokenExpiryDate1 > currentTime){
      // console.log("in auth not expired");
      // token not expird
          }else{

            // console.log( "in auth before await change;")
            const loggedInEmail = getUserEmail();

            let getdata =await fetchDataApi(loggedInEmail,refreshToken);
            accesToken = localStorage.getItem("accesToken");
       
            // console.log( "in auth after wawait;")
            //call refershToken
          }
  }else{
    delete jwtAxios.defaults.headers.common['x-auth-token'];
    localStorage.removeItem('token');
     localStorage.removeItem('PractitionerDetails');
   
   window.location.href='/login'
  }


 
  // console.log("in auth beofre  return11 ::",accesToken);
 
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: accesToken,
    },
  };
});

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL,
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false,
  }),
  link: authLink.concat(httpLink),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "network-only",
    },
  },
});


ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <App />
    <ToastContainer />
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
